import React from 'react';
import { Activity } from 'lucide-react';

export default function LiveFeed({ liveFeed, isRunning, feedRef }) {
  return (
    <div className="bg-gray-900 border border-green-500/30 rounded-xl overflow-hidden" style={{ maxHeight: "600px" }}>
      <div className="bg-black/50 px-4 py-3 border-b border-green-500/30 flex items-center justify-between">
        <h3 className="text-green-400 font-bold flex items-center gap-2">
          <Activity className="w-5 h-5 animate-pulse" />
          LIVE FEED
        </h3>
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-500">{liveFeed.length} logs</span>
          {isRunning && (
            <div className="flex items-center gap-1 text-xs text-green-400">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-ping"></div>
              STREAMING
            </div>
          )}
        </div>
      </div>
      <div ref={feedRef} className="p-3 overflow-y-auto font-mono text-xs space-y-1" style={{ maxHeight: "calc(600px - 50px)" }}>
        {liveFeed.length === 0 ? (
          <div className="text-center text-gray-600 py-20">
            <Activity className="w-8 h-8 mx-auto mb-2 opacity-50" />
            <div>Waiting for activity...</div>
          </div>
        ) : (
          liveFeed.map((log, i) => (
            <div key={i} className={`py-1 ${
              log.includes('SUCCESS') ? 'text-green-400' :
              log.includes('FAILED') ? 'text-red-400' :
              log.includes('TEST') ? 'text-blue-400' : 'text-gray-400'
            }`}>
              {log}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
